'use client';
import { SessionContext } from '@benzinga/session-context';
import { SubscribableEventType } from '@benzinga/subscribable';
import React from 'react';
import Hooks from '@benzinga/hooks';

import { useActiveWorkspaceSubscriber } from '@benzinga/pro-tools';
import { Watchlist, WatchlistManager } from '@benzinga/watchlist-manager';

export const useWatchlists = (updateCallback?: (watchlist: Watchlist[]) => void): Watchlist[] => {
  const session = React.useContext(SessionContext);
  const [toggle, update] = Hooks.useForceUpdateState();
  const watchlistManager = React.useMemo(() => session.getManager(WatchlistManager), [session]);

  useActiveWorkspaceSubscriber(watchlistManager, (event: SubscribableEventType<WatchlistManager>) => {
    switch (event.type) {
      case 'watchlist:updated_watchlists':
        if (updateCallback) {
          updateCallback(watchlistManager.getStoredWatchlists());
        } else {
          update();
        }
        break;
    }
  });

  return React.useMemo(
    () => (toggle ? watchlistManager.getStoredWatchlists() : watchlistManager.getStoredWatchlists()),
    [toggle, watchlistManager],
  );
};
